import { Controller } from "@hotwired/stimulus"
import { translate as t } from 'common/i18n'

function tpl(idx, classes, disciplines) {
  classes = classes.map(c => `<option value="${c[1]}">${c[0]}</option>`)
  disciplines = disciplines.map(d => `<option value="${d[1]}">${d[0]}</option>`)
  return `
    <div class="has-many-table-row grid-x">
      <div class="input select required person_special_classes_discipline_id cell auto shrink">
        <select data-people--special-classes-target="discipline" class="select required" name="person[special_classes_attributes][${idx}][discipline_id]" id="person_special_classes_attributes_${idx}_discipline_id">
          ${disciplines.join('')}
        </select>
      </div>
      <div class="input select required person_special_classes_class cell auto shrink">
        <select data-people--special-classes-target="class" class="select required" name="person[special_classes_attributes][${idx}][class]" id="person_special_classes_attributes_${idx}_class">
          ${classes.join('')}
        </select>
      </div>
      <div class="cell auto shrink padding-left-1" data-action="click->people--special-classes#remove:prevent">
        <button class="button alert small" type="button">${t('remove')}</button>
      </div>
    </div>
  `
}

export default class extends Controller {
  static targets = [
    'discipline', 
    'class'
  ]

  static values = {
    disciplines: Array,
    classes: Array,
  }

  connect() {
  }

  remove(e) {
    const row = e.target.closest('.has-many-table-row')
    row.remove()
  }

  add() {
    const index = this.maxIndex + 1
    this.element
      .querySelector('.has-many-table-body')
      .insertAdjacentHTML('beforeend', tpl(index, this.classesValue, this.disciplinesValue))
  }

  get maxIndex() {
    const indexes = this.disciplineTargets.
      map((i) => i.name.replace(/.*\[(\d+)\].*/, '$1'))
      .filter((x) => !isNaN(x))
      .map((x) => parseInt(x))
    return Math.max(...indexes, 0)
  }
}
